import { useMemo } from 'react';
import { simplifySegments } from '@/core/analysis/segments';
import type { AnalysisResult } from '@/core/analysis/types';
import { usePlayerStore } from './playerStore';
import { useSettingsStore } from './settingsStore';

/**
 * The open song's analysis as the views show it: chords simplified to the chosen complexity
 * (F2.11). Same beats and key; only the segments change. No re-analysis needed.
 */
export function useDisplayResult(): AnalysisResult | null {
  const result = usePlayerStore((s) => s.result);
  // Easy mode (F5.4) shows plain triads whatever the chord detail setting.
  const complexity = useSettingsStore((s) => (s.easyMode ? 'simple' : s.complexity));
  return useMemo(
    () =>
      result && {
        ...result,
        segments: simplifySegments(
          result.segments,
          complexity,
          result.key,
          result.beatGrid.beatsPerBar,
        ),
      },
    [result, complexity],
  );
}
